import { Stack, Tooltip, useTheme } from "@mui/material";
import { ReactComponent as BrokenIcon } from "../../assets/icons/brokenIcon.svg";
import useStyles from "./styles";
import { Typography } from "@mui/material";

interface ErroMessageProps {
  error?: string;
}

const ErroMessage = ({ error }: ErroMessageProps) => {
  const theme = useTheme();
  const style = useStyles(theme);

  const getErrorMessage = (error?: string | Error): string => {
    if (!error) return "Erro ao carregar os cards";
    if (typeof error === "string") return error;
    return "Erro ao mostrar dados";
  };

  return (
    <Stack sx={style.stack}>
      <BrokenIcon style={style.image} />
      <Stack sx={style.stackText}>
        <Typography sx={style.label}>{getErrorMessage(error)}</Typography>
      </Stack>
    </Stack>
  );
};

export default ErroMessage;
